import { useEffect, useState } from 'react';

import { Box } from '@aicon-dev/caas-ui';

import { PagePopup } from '~/components/ui/PagePopup';
import { PolicyService } from '~/modules/policy/Policy.Service';
import { useNavigate } from '~/router';

export default function TermsOfServicePolicy() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <PagePopup
      title="이용약관"
      visible={visible}
      onClose={() => setVisible(false)}
      onExited={() => navigate(-1)}
    >
      <Box p="16">
        <PolicyService />
      </Box>
    </PagePopup>
  );
}
